<section class="topSection">
    <div class="container nopad">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12 nopad">
                <h2 class="SectionHeading">Guidelines</h2>
            </div>
        </div>
        <mat-card class="mat-elevation-z8">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12 nopad">
                <!-- <hr /> -->
                <div class="col-md-3 col-sm-3 col-xs-12 floatLeft">
                    <!-- required for floating -->
                    <!-- Nav tabs -->
                    <ul id="GuidelineleftMenu" class="nav nav-tabs tabs-left sideways">
                        <li (click)="onClick(2)"><a href="#general-v" data-toggle="tab" class="active" routerLinkActive = "active">
                                <p>General</p>
                            </a></li>
                        <li (click)="onClick(5)"><a href="#institute-v" data-toggle="tab" routerLinkActive = "active">
                                <p>Institute</p>
                            </a></li>
                        <li (click)="onClick(6)"><a href="#student-v" data-toggle="tab" routerLinkActive = "active">
                                <p>Student</p>
                            </a></li>
                        <li (click)="onClick(8)"><a href="#faculty-v" data-toggle="tab" routerLinkActive = "active">
                                <p>Faculty</p>
                            </a></li>
                        <!-- <li (click)="onClick(3)"><a href="#expert-v" data-toggle="tab" routerLinkActive = "active">
                                <p>Expert</p>
                            </a></li>
                        <li (click)="onClick(1)"><a href="#AICTE-v" data-toggle="tab" routerLinkActive = "active">
                                <p>AICTE</p>
                            </a></li> -->
                    </ul>
                </div>

                <div class="col-md-9 col-sm-9 col-xs-12 floatLeft">
                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div class="tab-pane active" id="general-v">
                            <h3 style="color:#0d4f8b;text-align: center;">General Guidelines</h3>
                            <div *ngFor="let element of tempGuideline">
                                <img *ngIf="element.file" src="{{baseUrl}}/{{element.file}}"/>
                                <div class="videoContainer" *ngIf="element.url">
                                    <youtube-player videoId="{{element.video_id}}" HideProgressBar="2" Hide="0" [height]="350"
                                    [width]="802"></youtube-player>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="institute-v">
                            <h3 style="color:#0d4f8b;text-align: center;">Institute Guidelines</h3>
                            <div *ngFor="let element of tempGuideline">
                                <img *ngIf="element.file" src="{{baseUrl}}/{{element.file}}"/>
                                <div class="videoContainer" *ngIf="element.url">
                                    <youtube-player videoId="{{element.video_id}}" HideProgressBar="2" Hide="0" [height]="350"
                                    [width]="802"></youtube-player>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="student-v">
                            <h3 style="color:#0d4f8b;text-align: center;">Student Guidelines</h3>
                            <div *ngFor="let element of tempGuideline">
                                <img *ngIf="element.file" src="{{baseUrl}}/{{element.file}}"/>
                                <div class="videoContainer" *ngIf="element.url">
                                    <youtube-player videoId="{{element.video_id}}" HideProgressBar="2" Hide="0" [height]="350"
                                    [width]="802"></youtube-player>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="faculty-v">
                            <h3 style="color:#0d4f8b;text-align: center;">Faculty Guidelines</h3>
                            <div *ngFor="let element of tempGuideline">
                                <img *ngIf="element.file" src="{{baseUrl}}/{{element.file}}"/>
                                <div class="videoContainer" *ngIf="element.url">
                                    <youtube-player videoId="{{element.video_id}}" HideProgressBar="2" Hide="0" [height]="350"
                                    [width]="802"></youtube-player>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="expert-v">
                            <h3 style="color:#0d4f8b;text-align: center;">Expert Guidelines</h3>
                            <div *ngFor="let element of tempGuideline">
                                <img *ngIf="element.file" src="{{baseUrl}}/{{element.file}}"/>
                                <div class="videoContainer" *ngIf="element.url">
                                    <youtube-player videoId="{{element.video_id}}" HideProgressBar="2" Hide="0" [height]="350"
                                    [width]="802"></youtube-player>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="AICTE-v">
                            <h3 style="color:#0d4f8b;text-align: center;">AICTE Guidelines</h3>
                            <div *ngFor="let element of tempGuideline">
                                <img *ngIf="element.file" src="{{baseUrl}}/{{element.file}}"/>
                                <div class="videoContainer" *ngIf="element.url">
                                    <youtube-player videoId="{{element.video_id}}" HideProgressBar="2" Hide="0" [height]="350"
                                    [width]="802"></youtube-player>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="clearfix"></div>

            </div>
        </div>
        </mat-card>
    </div>
</section>

